import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/AppLayout";

const STATUS = {
  Active: { c: "#166534", b: "#DCFCE7" }, Degraded: { c: "#92400E", b: "#FEF3C7" },
  Error: { c: "#991B1B", b: "#FEE2E2" }, Disabled: { c: "#64748B", b: "#F1F5F9" },
};
const MARKETS = [
  { code: "", label: "Tutti i mercati" }, { code: "usa", label: "Stati Uniti" }, { code: "eu", label: "Unione Europea" },
  { code: "japan", label: "Giappone" }, { code: "china", label: "Cina" }, { code: "korea", label: "Corea del Sud" },
  { code: "taiwan", label: "Taiwan" }, { code: "turkey", label: "Turchia" }, { code: "eaeu", label: "EAEU" },
];
const MKT_LABEL = { usa: "USA", eu: "EU", japan: "JP", china: "CN", korea: "KR", taiwan: "TW", turkey: "TR", eaeu: "EAEU" };

export default function Sources() {
  const [sources, setSources] = useState([]);
  const [market, setMarket] = useState("");
  useEffect(() => { api.get("/sources", { params: market ? { market } : {} }).then((r) => setSources(r.data)); }, [market]);

  const active = sources.filter((s) => s.status === "Active").length;

  return (
    <div className="ri-fade-in">
      <PageHeader overline="Admin · Registro delle Fonti" title="Registro Fonti"
        subtitle="Fonti regolatorie per tutti i mercati coperti. Il sistema usa API/RSS quando disponibili e rispetta copyright e termini d'uso."
        actions={
          <select value={market} onChange={(e) => setMarket(e.target.value)} data-testid="sources-market-filter"
            className="px-3 py-2 rounded-lg border border-slate-200 text-sm bg-white">
            {MARKETS.map((m) => <option key={m.code} value={m.code}>{m.label}</option>)}
          </select>
        } />

      <div className="flex gap-3 mb-4 text-xs text-slate-500">
        <span>{sources.length} fonti</span>·<span className="text-green-700">{active} attive</span>
      </div>

      <div className="rounded-xl bg-white border border-slate-200 overflow-x-auto">
        <table className="ri-table">
          <thead><tr>
            <th>Authority</th><th>Mercato</th><th>Paese</th><th>Tipo</th><th>Metodo</th><th>Frequenza</th>
            <th>Lingua</th><th>Licenza</th><th>Stato</th><th>Ultimo sync</th>
          </tr></thead>
          <tbody>
            {sources.map((s) => {
              const st = STATUS[s.status] || STATUS.Disabled;
              return (
                <tr key={s.id} data-testid={`source-row-${s.id}`}>
                  <td className="font-medium">{s.authority}</td>
                  <td><span className="text-xs font-mono px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">{s.market ? (MKT_LABEL[s.market] || s.market) : "INT"}</span></td>
                  <td className="text-slate-500">{s.country}</td>
                  <td className="text-xs">{s.source_type}</td>
                  <td className="text-xs font-mono">{s.method}</td>
                  <td className="text-xs">{s.frequency}</td>
                  <td className="text-xs">{s.language}</td>
                  <td className="text-xs text-slate-400 max-w-[160px] truncate">{s.license}</td>
                  <td><span className="text-xs font-medium px-2 py-0.5 rounded-full" style={{ color: st.c, background: st.b }}>{s.status}</span></td>
                  <td className="text-xs text-slate-400">{s.last_success ? s.last_success.slice(0, 10) : "—"}{s.errors && <div className="text-[0.65rem] text-red-500">{s.errors}</div>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
